import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ComponentsModule } from 'src/app/components/components.module';
import { B3DesignSystemWebModule } from 'src/app/shared/b3-design-system-web/b3-design-system-web.module';

import { CreditRegisterService } from '../credit-register/service/credit-register.service';
import {
  CharacteristicConsultDetailsDrawerComponent,
} from './characteristic-consult-details-drawer/characteristic-consult-details-drawer.component';
import {
  CharacteristicConsultErrorModalComponent,
} from './characteristic-consult-error-modal/characteristic-consult-error-modal.component';
import {
  CharacteristicConsultFilterComponent,
} from './characteristic-consult-filter/characteristic-consult-filter.component';
import { CharacteristicConsultListComponent } from './characteristic-consult-list/characteristic-consult-list.component';
import { CharacteristicConsultComponent } from './characteristic-consult.component';

@NgModule({
  declarations: [
    CharacteristicConsultComponent,
    CharacteristicConsultListComponent,
    CharacteristicConsultFilterComponent,
    CharacteristicConsultDetailsDrawerComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    OverlayModule,
    ComponentsModule,
    B3DesignSystemWebModule,
    CharacteristicConsultErrorModalComponent,
  ],
  exports: [
    CharacteristicConsultComponent,
  ],
  providers: [
    CreditRegisterService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CharacteristicConsultModule { }
